import { createFileRoute } from '@tanstack/react-router';
import { tiktokStaticData } from '../../tiktok';
import { saveCountryIdBeforeLoad } from '../../instagram';

export const Route = createFileRoute('/_private-routes/hashtag-analytics/tiktok/hashtag/$countryId')({
  staticData: tiktokStaticData,
  parseParams: (params) => ({ ...params, countryId: params.countryId.toLowerCase() }),
  beforeLoad: saveCountryIdBeforeLoad({ to: '/hashtag-analytics/tiktok/hashtag' })
});
